module.exports = __webpack_public_path__ + "static/media/protocogotas_text_03.d76caaf1.jpg";